import { graphql } from 'react-relay';

import { type FragmentRef } from '@confluence/apollo-relay-interop/entry-points/useFragmentizedQuery.ts';
import { useFragmentizedFragment } from '@confluence/apollo-relay-interop/entry-points/useFragmentizedFragment.ts';

import type { ContentTypesHeaderQueryNode } from './ContentTypesHeader.tsx';
import type { useContentSpaceFragment$data } from './__generated__/useContentSpaceFragment.graphql.ts';

type ContentSpace = Omit<useContentSpaceFragment$data, ' $fragmentType'>;
export const useContentSpace = (
	contentSpaceRef: FragmentRef,
	externalShareContent?: ContentTypesHeaderQueryNode | null,
): ContentSpace | null => {
	if (externalShareContent?.space) {
		return {
			id: externalShareContent.space.id,
			name: externalShareContent.space.name,
			key: externalShareContent.space.key,
			alias: externalShareContent.space.alias,
		};
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	return useFragmentizedFragment<ContentSpace>(
		graphql`
			fragment useContentSpaceFragment on Space {
				id
				name
				key
				alias
			}
		`,
		contentSpaceRef,
	);
};
